module.exports = __webpack_public_path__ + "0833ab847d2655ac5c82ab9bd3db4f68.svg";